import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/custom-statuses/{customStatusId}/archive';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

/**
 * Archives a custom status. Existing workflow steps that reference the status
 * by slug continue to work, but the status is hidden from selection UIs.
 */
const archiveCustomStatus = async ({ customStatusId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { customStatusId });
  const response = await noodleApiClient.post(path);
  return response.data;
};

export default archiveCustomStatus;
